/* Employee Page*/
import React from "react"; // useState //useEffec
import MetaTags from "react-meta-tags";
// import { toast, ToastContainer } from "react-toastify";
import { useState, useEffect } from "react";
import {
  Col,
  Row,
  Button,
  Table,
  Input,
  Typography,
  DatePicker,
  Space,
} from "antd";
import {
  DownloadOutlined,
  SearchOutlined,
  ReloadOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import * as action from "../../store/Reports/actions";
import "../Dashboard/index.css";
import "../LeaveAndPermissions/LeaveDetails.css";
import { useSelector, useDispatch } from "react-redux";
import BreadcrumbComponent from "../../components/BreadCrumb";
import dayjs from "dayjs";
// import duration from "dayjs/plugin/duration";
import api from "../../helpers";
import { isEmpty } from "lodash";

const BCrumb = [{ to: "/", title: "Home" }, { title: "Attendance Details" }];

const AttendanceView = () => {
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [searchValue, setSearchValue] = useState({
    limit: 10,
    page: 1,
  });

  const specificDispatch = useDispatch();
  const dispatch = useDispatch();

  const attendenceUpdate = useSelector((state) => state.Reports);
  const { attendanceViewList = {} } = attendenceUpdate;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalCount, setTotalCount] = useState(attendanceViewList?.count); // get this from your API response

  //initial api call
  useEffect(() => {
    specificDispatch(action.loadAttendanceView({ limit: 10, page: 1 }));
  }, [specificDispatch]);

  //table data

  const [searchLoading, setSearchLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [resetLoading, setResetLoading] = useState(false);

  const [selectedDate, setSelectedDate] = useState({
    label: dayjs().format("YYYY-MM-DD"),
    value: dayjs(),
  });

  // const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (attendanceViewList) {
      setTotalCount(attendanceViewList?.count); // total is total count of records in the backend
    }
  }, [attendanceViewList]);

  const tableData = Array.isArray(attendanceViewList?.data)
    ? attendanceViewList.data.flatMap((employee, empIndex) =>
        (employee.intervalDatas || []).map((interval, i) => ({
          key: `${employee.employeeId}-${interval.date}`,
          sno: empIndex + 1,
          name: employee.employeeName,
          employeeCode: employee.employeeCode,
          designationName: employee.department || "--",
          login: interval.login,
          lunchOut: interval.lunchOut,
          lunchIn: interval.lunchIn,
          breakOut: interval.breakOut,
          breakIn: interval.breakIn,
          logout: interval.logout,
          totalHours: interval.netWorkDuration,
        }))
      )
    : [];

  //table columns
  const columns = [
    {
      title: <span className="poppins-txt">S.No</span>,
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Name</span>,
      dataIndex: "name",
      key: "name",
      width: 200,
      className: "poppins-txt-lg",
      render: (_, record) => (
        <div style={{ lineHeight: 1.5 }}>
          <strong>
            {record.employeeCode} - {record.name}
          </strong>
          <div style={{ color: "#1890ff", fontSize: "14px" }}>
            {record.designationName || "--"}
          </div>
        </div>
      ),
    },
    {
      title: <span className="poppins-txt">Login</span>,
      dataIndex: "login",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Lunch Out</span>,
      dataIndex: "lunchOut",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Lunch In</span>,
      dataIndex: "lunchIn",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Break Out</span>,
      dataIndex: "breakOut",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Break In</span>,
      dataIndex: "breakIn",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Logout</span>,
      dataIndex: "logout",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Total Working Hours</span>,
      dataIndex: "totalHours",
      width: 160,
      className: "poppins-txt-lg",
      render: (text) => <strong>{text}</strong>,
    },
  ];

  //download csv
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = async () => {
    setDownloadLoader(true);
    let searchFilter = {};
    if (dayjs.isDayjs(selectedDate?.value)) {
      searchFilter.date = selectedDate.value.format("YYYY-MM-DD");
    } else if (typeof selectedDate?.value === "string") {
      searchFilter.date = selectedDate.value;
    }

    try {
      const res = await api.post(
        "/auth/attendance/getattendancedetails",
        searchFilter
      );
      const employees = res.data?.data || [];

      const tableData = Array.isArray(employees)
        ? employees.flatMap((employee, empIndex) =>
            (employee.intervalDatas || []).map((interval, i) => ({
              key: `${employee.employeeId}-${interval.date}`,
              sno: empIndex + 1,
              name: employee.employeeName,
              employeeCode: employee.employeeCode,
              designationName: employee.department || "--",
              login: interval.login,
              lunchOut: interval.lunchOut,
              lunchIn: interval.lunchIn,
              breakOut: interval.breakOut,
              breakIn: interval.breakIn,
              logout: interval.logout,
              totalHours: interval.netWorkDuration,
            }))
          )
        : [];

      const attendanceHeaders = [
        "S.No",
        "Name",
        "Login",
        "Lunchout",
        "Lunchin",
        "Break Out",
        "Break In",
        "Logout",
        "Total Working Hours",
      ];

      const attendanceCsvContent = tableData.map((item) => [
        item.sno ?? "--",
        item.name ?? "--",
        item.login || "--",
        item.lunchOut || "--",
        item.lunchIn || "--",
        item.breakOut || "--",
        item.breakIn || "--",
        item.logout || "--",
        item.totalHours || "--",
      ]);

      const attendanceCsvString = [
        attendanceHeaders.join(","),
        ...attendanceCsvContent.map((row) => row.join(",")),
      ].join("\n");

      downloadFile({
        data: attendanceCsvString,
        fileName: "attendance.csv",
        fileType: "text/csv",
      });
    } catch (err) {
    } finally {
      setDownloadLoader(false);
    }
  };

  //filter functionality

  const handleFilter = (e) => {
    e.preventDefault();
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);

    const searchFilter = {
      limit: pageSize,
      page: currentPage,
    };

    if (dayjs.isDayjs(selectedDate?.value)) {
      searchFilter.date = selectedDate.value.format("YYYY-MM-DD");
    } else if (typeof selectedDate?.value === "string") {
      searchFilter.date = selectedDate.value;
    }
    setSearchValue(searchFilter);
    if (!isEmpty(searchFilter)) {
      dispatch(action.loadAttendanceView(searchFilter));
    } else {
      dispatch(action.loadAttendanceView({ limit: 10, page: 1 }));
    }
  };

  const handlePreset = (preset) => {
    if (preset === "today") {
      setSelectedDate({ label: "Today", value: dayjs() });
    } else if (preset === "yesterday") {
      setSelectedDate({
        label: "Yesterday",
        value: dayjs().subtract(1, "day"),
      });
    }
  };

  // search
  const handleSearch = () => {
    const payload = {
      search: searchInput,
    };
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    dispatch(action.loadAttendanceView(payload));
  };

  //filter reset functionality
  const onReset = () => {
    setSearchInput("");
    setResetLoading(true);
    setSearchValue({
      limit: 10,
      page: 1,
    });
    setTimeout(() => {
      setResetLoading(false);
      // setSelectedDate([]);
      setSelectedDate({
        label: dayjs().format("YYYY-MM-DD"),
        value: dayjs(),
      });
    }, 1000);
    setCurrentPage(1);
    dispatch(
      action.loadAttendanceView({
        limit: 10,
        page: 1,
      })
    );
  };

  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>Attendance Details | Mequals</title>
        </MetaTags>
      </div>
      <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="Attendance Details" items={BCrumb} />
        </Col>
      </Row>
      <Col span={24}>
        <div
          style={{
            background: "#ffffff",
            margin: "4px 8px 4px 8px", // top, right, bottom, left
            padding: "20px",
            borderRadius: "8px 8px 0px 0px",
          }}
        >
          <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
            <Col xs={24} sm={12} md={8} lg={6} xl={6}>
              <div>
                <div className="mb-2">
                  <Typography className="poppins-txt">Date</Typography>
                </div>
                <DatePicker
                  className="custom-select py-2"
                  value={
                    dayjs.isDayjs(selectedDate?.value)
                      ? selectedDate.value
                      : null
                  }
                  onChange={(date) =>
                    setSelectedDate({ label: "Custom", value: date })
                  }
                  renderExtraFooter={() => (
                    <div style={{ textAlign: "center" }}>
                      <Space>
                        <Button
                          size="small"
                          onClick={() => handlePreset("today")}
                        >
                          Today
                        </Button>
                        <Button
                          size="small"
                          onClick={() => handlePreset("yesterday")}
                        >
                          Yesterday
                        </Button>
                      </Space>
                      <div
                        style={{ marginTop: 8, fontSize: 12, color: "#999" }}
                      >
                        Selected:{" "}
                        {dayjs.isDayjs(selectedDate?.value)
                          ? selectedDate.value.format("YYYY-MM-DD")
                          : selectedDate?.label || "None"}
                      </div>
                    </div>
                  )}
                />
              </div>
            </Col>
            <Col>
              <div className="mt-7">
                <Button
                  className="custom-btn"
                  icon={<ReloadOutlined style={{ fontSize: "16px" }} />}
                  size="middle"
                  onClick={onReset}
                  loading={resetLoading}
                  danger
                  style={{ marginRight: "12px" }}
                >
                  Reset
                </Button>
                <Button
                  className="custom-btn"
                  type="primary"
                  size="middle"
                  icon={<FilterOutlined style={{ fontSize: "18px" }} />}
                  htmlType="submit"
                  onClick={handleFilter}
                  loading={searchLoading}
                >
                  Apply Filter
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        <div
          style={{
            background: "#ffffff",
            margin: "20px 8px 15px 8px", // top, right, bottom, left
            padding: "16px",
          }}
        >
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: 16 }}
          >
            <Col>
              <Input
                placeholder="Search..."
                allowClear
                style={{ width: 250, fontFamily: "Poppins" }}
                name="searchInput"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                type="text"
                autoComplete="off"
              />

              <Button
                icon={<SearchOutlined />}
                type="primary"
                style={{ marginLeft: 8 }}
                onClick={handleSearch}
              />
            </Col>
            <Col>
              <Button
                className="custom-btn"
                size="medium"
                type="primary"
                icon={<DownloadOutlined />}
                loading={downloadLoader}
                onClick={exportToCsv}
              >
                Download
              </Button>
            </Col>
          </Row>

          <Table
            loading={searchLoading}
            columns={columns}
            dataSource={tableData}
            className="poppins-txt"
            rowKey="key"
            rowClassName={"text-[12px]"}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: totalCount, // make sure you provide total count from API
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "30"],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total}`,
            }}
            sortDirections={"ascend"}
            showSorterTooltip={"sorter-icon"}
            scroll={{
              x: 765,
            }}
            onChange={(pagination, filters, sorter) => {
              const { current, pageSize } = pagination;
              setCurrentPage(current); // you can manage currentPage and pageSize in your component state if needed
              setPageSize(pageSize);
              const updatedParams = {
                ...searchValue,
                page: current,
                limit: pageSize,
              };

              setSearchValue(updatedParams);
              specificDispatch(action.loadAttendanceView(updatedParams));
            }}
          />
        </div>
      </Col>
    </React.Fragment>
  );
};
//AttendanceView
export default AttendanceView;
